exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1 {\r\n    text-align: left;\r\n    color: black;\r\n    font-family: \"Myriad Pro\";\r\n    margin-bottom: 30px;\r\n}\r\n\r\ndiv.gallery-container {\r\n    margin-top: 0;\r\n    width: 100%;\r\n    background-color: white;\r\n    margin-bottom: 20px;\r\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\np {\r\n    color: #7a7a7a;\r\n    font-size: 20px;\r\n    font-family: \"Myriad Pro\";\r\n    letter-spacing: -0.025em;\r\n}\r\n\r\n.container {\r\n    max-width: 900px;\r\n    width: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/gallery/gallery.component.css
// module id = 753
// module chunks = 1